<template>
  <div class="accepted-container">
    <el-table :data="requirementList"
              size="mini"
              style="width: 100%"
              height="100%">
      <el-table-column prop="itemName"
                       label="物料名称"
                       width="250">
      </el-table-column>
      <el-table-column prop="itemCode"
                       label="物料编码"
                       width="150">
      </el-table-column>
      <el-table-column prop="brandName"
                       label="品牌"
                       width="120">
      </el-table-column>
      <el-table-column prop="modelName"
                       label="机型"
                       width="150">
      </el-table-column>
      <el-table-column prop="moduleName"
                       label="模块"
                       width="150">
      </el-table-column>
      <el-table-column label="品项"
                       width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.qualityName | qualityType"
                  size="mini">
            {{ scope.row.qualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="报价品项"
                       width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.quoteQualityName | qualityType"
                  size="mini">
            {{ scope.row.quoteQualityName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="quantity"
                       label="数量"> </el-table-column>
      <el-table-column prop="quoteQuantity"
                       label="报价数量"> </el-table-column>
      <el-table-column prop="price"
                       label="单价"> </el-table-column>
      <el-table-column prop="quoteRemark"
                       label="备注"
                       width="200">
      </el-table-column>
      <el-table-column prop="dueDate"
                       label="到期日"
                       width="180">
        <template slot-scope="scope">
          {{ scope.row.dueDate | date }}
        </template>
      </el-table-column>
      <el-table-column label="状态"
                       width="120"
                       prop="state">
        <template slot-scope="scope">
          <span v-if="scope.row.invalid">已失效</span>
          <span v-else>{{ scope.row.state }}</span>
        </template>
      </el-table-column>
      <el-table-column label="产品图片"
                       width="100">
        <template slot-scope="scope">
          <el-image :src="`http://www.spr-atm.com/Seller/ShowImage?code=${scope.row.itemCode}`"
                    :preview-src-list="previewFiles(scope.row.itemCode)"
                    style="width:40px; height:40px">
            <div slot="error"
                 class="image-slot">
              <img src="@images/watermark.jpg"
                   style="width: 40px; height: 40px;"
                   alt="" />
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="120"
                       align="center"
                       fixed="right">
        <template slot-scope="scope">
          <el-button type="text"
                     v-if="!scope.row.invalid"
                     @click="handleInvalid(scope.row.id)">
            失效
          </el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="失效原因"
               :visible.sync="isShowInvalidDialog"
               width="500px"
               :before-close="handleDialogClose"
               class="invalid-dialog">
      <el-form ref="invalidFormRef"
               :model="invalidForm">
        <el-form-item>
          <el-radio-group v-model="invalidForm.invalidReason"
                          @change="handleChange">
            <el-radio label="缺货"
                      name="invalidReason"></el-radio>
            <el-radio label="货物质量问题"
                      name="invalidReason"></el-radio>
            <el-radio label="价格调整"
                      name="invalidReason"></el-radio>
            <el-radio label="信息录入错误"
                      name="invalidReason"></el-radio>
            <el-radio label="其他"
                      name="invalidReason"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input v-model="invalidForm.otherInvalidReason"
                    type="textarea"
                    maxlength="30"
                    v-if="isShowArea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="handleConfirm"
                   size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    requirementList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isShowInvalidDialog: false,
      isShowArea: false,
      invalidId: '',
      invalidForm: {
        invalidReason: '',
        invalidType: 1,
        otherInvalidReason: ''
      }
    }
  },
  created () {
    // console.log(this.requirementList);
  },
  methods: {
    previewFiles (itemCode) {
      let arr = []
      arr.push(`http://www.spr-atm.com/Seller/ShowImage?code=${itemCode}`)
      return arr
    },
    handleInvalid (id) {
      this.isShowInvalidDialog = true
      this.invalidId = id
    },
    handleChange (value) {
      if (value === '其他') {
        this.isShowArea = true
      } else {
        this.isShowArea = false
        this.otherInvalidReason = ''
      }
    },
    handleDialogClose (done) {
      this.isShowArea = false
      this.invalidForm = {
        invalidReason: '',
        invalidType: 1,
        otherInvalidReason: ''
      }
      done()
    },
    handleConfirm () {
      let invalidCause = ''
      if (this.invalidForm.otherInvalidReason === '') {
        invalidCause = this.invalidForm.invalidReason
      } else {
        invalidCause = '其他： ' + this.invalidForm.otherInvalidReason
      }
      let invalidType = ''
      switch (this.invalidForm.invalidReason) {
        case '缺货':
          invalidType = 1
          break
        case '货物质量问题':
          invalidType = 2
          break
        case '价格调整':
          invalidType = 3
          break
        case '信息录入错误':
          invalidType = 4
          break
        case '其他':
          invalidType = 5
          break

        default:
          break
      }
      const params = {
        invalidCause,
        invalidType,
        id: this.invalidId
      }
      this.$http
        .put('/api/services/inquiryApp/dIDetail/Invalid', params)
        .then(res => {
          if (res.success) {
            this.$message.success('操作成功！')
            this.$emit('getRequirementList')
            this.isShowInvalidDialog = false
            this.isShowArea = false
            this.invalidForm = {
              invalidReason: '',
              otherInvalidReason: ''
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
  }
}
</script>
<style lang="less" scoped>
.accepted-container {
  height: 100%;
  overflow: auto;
}
.invalid-dialog {
  /deep/ .el-dialog__body {
    padding: 0 20px;
    .el-form-item {
      margin-bottom: 0;
    }
    .el-radio {
      display: block;
      padding: 10px 0;
    }
  }
}
</style>
